import React from "react";
import "./Testimonial.scss";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import TestimoniCard from "../../components/TestimoniCard/TestimoniCard";
import Slider from "react-slick";

const Testimonial = () => {
    const testimonails = [
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Mandar Remane",
            reviewUrl:
                "https://maps.app.goo.gl/AeQc1tad8dFRHtGW9",
            text: "I was having display issue in laptop, they diagnosed the issue very quickly and suggested to replace the display, The service was excellent! They replaced the screen in just one day, and the communication was transparent. My PC is working perfectly now, Highly recommend them.",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Saurabh Phadnis",
            reviewUrl:
                "https://maps.app.goo.gl/17B14dNvENCugH2u7",
            text: "Awesome place for the service and the system of the office to gud and the owner was so friendly for talking and all works..",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Yogesh Yewale",
            reviewUrl:
                "https://maps.app.goo.gl/Uh38SZcKWy9ZBprG7",
            text: "The Best Service all the time , immediate response and solution with cost effective concept .All professional staff as well as everything system wise.",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Gaurav Dhainje",
            reviewUrl:
                "https://maps.app.goo.gl/yuFkDpMwrTz7dUg1A",
            text: "Overall the service was great.I got products delivered as per market rate.And I did receive the product when it was urgent and didn't have to wait like Amazon which takes 4-5 days to  deliver.",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Abhiraj Deshpande",
            reviewUrl:
                "https://maps.app.goo.gl/Ns3vgmuh2M1uxgV87",
            text: "Very good staff and helpfull. I got my 3 laptops repaired from there which are working very efficiently at very good price and also had cameras fixed at my house, overall service was good .",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Akshata Botre",
            reviewUrl:
                "https://maps.app.goo.gl/mBPGfdBJVq3kXkUg8",
            text: "Reasonable rate with good service ..happy with the service with good equality 👍🏻!",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Sandip Mangawade",
            reviewUrl:
                "https://maps.app.goo.gl/yndFKtcpiju7ceN4A",
            text: "Very Good Services Thanks Team Rohan Systems",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Dipak Manke",
            reviewUrl:
                "https://maps.app.goo.gl/fAKoc9u8tved6ggk7",
            text: "Very good service minimum Prise Positive Responsiveness, Quality, Professionalism, Value",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Sheetal Shinde",
            reviewUrl:
                "https://maps.app.goo.gl/ydtqx15UPbjRPoRA8",
            text: "Very good service 👍Positive Responsiveness, Quality, Professionalism, Value",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Vanita Patil",
            reviewUrl:
                "https://maps.app.goo.gl/kYxh3BM8FCH2omY39",
            text: "Very good serviceI am happy Positive Responsiveness, Quality, Professionalism, Value",
        },
        {
            title: "Rohan Systems",
            url: "https://www.google.com/maps/place/Rohan+Systems/@18.6589034,73.8083856,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b82665d274dd:0xa96bb87c2df8db29!8m2!3d18.6589034!4d73.8083856!16s%2Fg%2F1pp2w_1xf?entry=ttu&g_ep=EgoyMDI1MDQxNi4xIKXMDSoASAFQAw%3D%3D",
            stars: 5,
            name: "Sahil P",
            reviewUrl:
                "https://maps.app.goo.gl/oNVr3hhFJHEwuagR7",
            text: "Best service....and good people. Nice environment",
        },
   
    ];

    // slider
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section
            id="testimonial-section"
            className="section-bg common-padding"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <SectionTitle
                            subTitle="TESTIMONIAL"
                            title="What people have said about us"
                            googleReviews={true}
                        />
                    </div>
             
                </div>

                <Slider {...settings} className="testimoni-slider">
                    {testimonails
                        .filter((testimonail) => testimonail.text?.trim()) // Exclude null or empty text
                        .map((testimonail) => (
                            <TestimoniCard
                                key={testimonail.id}
                                testimonail={testimonail}
                            />
                        ))}
                </Slider>
                <div className="swipe-indicator text-center mt-4">
                    <p style={{ color: "white" }}>
                        <span style={{ fontSize: "24px" }}>•••</span> Swipe to see more reviews
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;
